import { postComplaintCase } from './complaints.ts'
import { postMysterySwitchCase } from './mystery-switch.ts'

export default {
  postComplaintCase,
  postMysterySwitchCase
}
